import { DemoImageOcrGallery } from '@/pages/demo/components/DemoImageOcrGallery';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { useState } from 'react';

export const DemoPostProcessPage = () => {
  const [prescriptionMonth, setPrescriptionMonth] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">시연 관리자 홈 — Post Process</h1>
        <p className="text-muted-foreground">
          OCR 결과와 MaxMatch Lite post-process 응답을 비교하는 실험 영역입니다.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">도장 생성기</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          레거시 DemoStampGenerator는 후속 작업으로 이관 예정입니다. OCR·post-process 시연은 아래 갤러리에서
          사용할 수 있습니다.
        </CardContent>
      </Card>

      <div className="flex items-center gap-2">
        <label htmlFor="demo-pp-month" className="text-sm font-medium">
          처방 년월
        </label>
        <input
          id="demo-pp-month"
          type="month"
          value={prescriptionMonth}
          onChange={(e) => setPrescriptionMonth(e.target.value)}
          className="rounded-md border px-2 py-1 text-sm"
        />
      </div>

      <DemoImageOcrGallery
        prescriptionMonth={prescriptionMonth}
        enablePostProcess
        useTaskQueueOcrClient
      />
    </div>
  );
};
